import React, {useContext, useEffect, useState} from 'react'
import styled from 'styled-components'
import AuthUserContext from '../../providers/AuthProvider';
import { getUserPublicInformation } from '../../services/user.services';
import { BreakpointSmallMobile, BreakpointMobile } from '../Layout/GlobalStyle';
import moment from 'moment'
import {makeStyles} from '@material-ui/styles';
import IconButton from '@material-ui/core/IconButton';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import UpdatePictureDialog from '../UpdatePictureDialog/UpdatePictureDialog';


const useStyles = makeStyles((theme) => ({
    photoButton: {
        position: "absolute",
        bottom: 2,
        right: 15,
        width: 40,
        fontSize: 22,
        height: 40,
        padding: 5,
        background: "white",
        color: 'rgba(0,0,0,0.87)',
        "&:hover": {
            background: "#cacaca"
        },
        [`@media only screen and (max-width: ${BreakpointMobile + 'px'})`]: {
            position: "absolute",
            bottom: 2,
            right: 30,
            height: 30,
            width: 30,
            fontSize: 18,
            padding: 5,
            background: "white",
            color: 'rgba(0,0,0,0.87)',
        }
    }
}))

const SettingsHeader = styled.div`
    background: var(--Color1);
    height: 350px;
    width: 100%;

    @media only screen and (max-width: ${BreakpointSmallMobile + 'px'}){
        height: 200px;
    }
`
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: inherit;
    .name-wrapper{
        text-align: center;
        font-family: var(--Font1);
        color: white;
        font-size: x-large;
        text-shadow: 2px 2px rgba(0,0,0,0.1);
        line-height: normal;
        padding-top: 15px;

        @media only screen and (max-width: ${BreakpointSmallMobile + 'px'}){
            font-size: large;
        }

    }

    .email-wrapper{
        text-align: center;
        font-family: var(--Font1);
        color: white;
        line-height: normal;
        padding-top: 5px;

        font-size: medium;
        text-shadow: 2px 2px rgba(0,0,0,0.1);

    }

    .member-since-wrapper{
        text-align: center;
        font-family: var(--Font2);
        color: white;
        font-size: small;
        padding-top: 5px;
        line-height: normal;

        text-shadow: 2px 2px rgba(0,0,0,0.1);
    }
    
`

const AvatarWrapper = styled.div`
    position: relative;
`

const Avatar = styled.div`
    width: 150px;
    height: 150px;
    border-radius: 75px;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: ${props => props.src? `url(${props.src})`: ``};
    margin: auto;
    box-shadow: 2px 2px rgba(0,0,0,0.1);
    border: 4px solid white;


    @media only screen and (max-width: ${BreakpointMobile + 'px'}){
         width: 100px;
         height: 100px;
         border-radius: 50px;

    }

    @media only screen and (max-width: ${BreakpointSmallMobile + 'px'}){
         width: 80px;
         height: 80px;
         border-radius: 40px;

    }
`

function UserSettingsHeader() {
    const classes = useStyles()
    const [updateAvatarOpen, setUpdateAvatarOpen] = useState(false)
    const [user, setUser] = useState({   
        _id: "",
        first_name: "",
        last_name: "",
        avatar: ""
    })
    const {user: userInContext, isTheUserLoggedIn, userAvatar} = useContext(AuthUserContext) 
    
    // START OF USE EFFECTS

    
    // END OF USE EFFECTS

    // START OF API CALLS

 

  

    // END OF API CALLS

    return (
        <>
        <UpdatePictureDialog setOpen={setUpdateAvatarOpen} open={updateAvatarOpen} userID={userInContext.id} oldPicture={userAvatar} />
        <SettingsHeader >

        <Container>
            <div className="avatar-and-name">
                <AvatarWrapper>

                <Avatar src={userAvatar} />
                <IconButton onClick={() => setUpdateAvatarOpen(true)} size="small" className={classes.photoButton}>
                    <AddAPhotoIcon  style={{fontSize: "inherit"}}/>
                </IconButton>
                </AvatarWrapper>

                <div className="name-wrapper">
                    {userInContext.first_name + " " + userInContext.last_name}
                </div>
                {userInContext.created_at? 
                <div className="member-since-wrapper">
                    Member since {moment(userInContext.created_at).format("MMM, YYYY")}
                </div>: ""}
            </div>

            
        </Container>
        </SettingsHeader>
        </>

    )
}


export default UserSettingsHeader;